import { render, staticRenderFns } from "./PlansView.vue?vue&type=template&id=266ebfd6&scoped=true&"
import script from "./PlansView.vue?vue&type=script&lang=js&"
export * from "./PlansView.vue?vue&type=script&lang=js&"
import style0 from "./PlansView.vue?vue&type=style&index=0&id=266ebfd6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "266ebfd6",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VImg } from 'vuetify/lib/components/VImg';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VBtn,VContainer,VImg,VRow,VTextField})
